/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AcceptConsultParams,
  ConnectTranscriptionParams,
  DeclineConsultParams,
  DeleteSessionNotePayload,
  GetAllSessionsParams,
  GetClientConsultParams,
  GetClientConsultsParams,
  ModelsConsultReview,
  ModelsConsultStatus,
  RequestUpdateSessionNotesRequest,
  ResponseConsultResponse,
  ResponseConsultsConsultSessionDetailsForAnalysisResponse,
  ResponseConsultsNoteAttachmentFile,
  ResponsePsychologistConsultInformationResponsePaginated,
  ResponseTwoFactorNotEnforcedConsultResponse,
  UploadSessionNoteAttachmentPayload,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Consults<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Consults
   * @name AcceptConsult
   * @summary  (Auth policies: GuestOrClientOrExpertPolicy)
   * @request POST:/api/v1/consults/{consultId}/accept
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  acceptConsult = (
    { consultId, ...query }: AcceptConsultParams,
    params: RequestParams = {},
  ) =>
    this.http.request<void, void>({
      path: `/api/v1/consults/${consultId}/accept`,
      method: "POST",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags SessionNotes
   * @name AddOUpdateSessionNote
   * @summary Add session notes to a Consult (Auth policies: ExpertPolicy)
   * @request POST:/api/v1/consults/{consultId}/session-notes
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  addOUpdateSessionNote = (
    consultId: number,
    data: RequestUpdateSessionNotesRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<void, void>({
      path: `/api/v1/consults/${consultId}/session-notes`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Transcription
   * @name ConnectTranscription
   * @summary  (Auth policies: ExpertPolicy)
   * @request POST:/api/v1/consults/{consultId}/transcription/connect
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  connectTranscription = (
    { consultId, ...query }: ConnectTranscriptionParams,
    params: RequestParams = {},
  ) =>
    this.http.request<void, void>({
      path: `/api/v1/consults/${consultId}/transcription/connect`,
      method: "POST",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Consults
   * @name DeclineConsult
   * @summary  (Auth policies: GuestOrClientOrExpertPolicy)
   * @request POST:/api/v1/consults/{consultId}/decline
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  declineConsult = (
    { consultId, ...query }: DeclineConsultParams,
    params: RequestParams = {},
  ) =>
    this.http.request<void, void>({
      path: `/api/v1/consults/${consultId}/decline`,
      method: "POST",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags SessionNotes
   * @name DeleteSessionNote
   * @summary Delete session notes from a Consult (Auth policies: ExpertPolicy)
   * @request DELETE:/api/v1/consults/{consultId}/session-notes
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  deleteSessionNote = (
    consultId: number,
    data: DeleteSessionNotePayload,
    params: RequestParams = {},
  ) =>
    this.http.request<void, void>({
      path: `/api/v1/consults/${consultId}/session-notes`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags SessionNotes
   * @name DeleteSessionNoteAttachment
   * @summary  (Auth policies: ExpertPolicy)
   * @request DELETE:/api/v1/consults/{consultId}/session-notes/attachments/{fileName}
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  deleteSessionNoteAttachment = (
    consultId: number,
    fileName: string,
    params: RequestParams = {},
  ) =>
    this.http.request<void, void>({
      path: `/api/v1/consults/${consultId}/session-notes/attachments/${fileName}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Consults
   * @name GetAllSessions
   * @summary Allow a managing psychologist to get all the sessions (Auth policies: HostOrSupportOrManagingPsychologistPolicy)
   * @request GET:/api/v1/consults/all-sessions
   * @secure
   * @response `200` `ResponsePsychologistConsultInformationResponsePaginated` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getAllSessions = (query: GetAllSessionsParams, params: RequestParams = {}) =>
    this.http.request<
      ResponsePsychologistConsultInformationResponsePaginated,
      void
    >({
      path: `/api/v1/consults/all-sessions`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consults
   * @name GetClientConsult
   * @summary Get the consult for a given user (Auth policies: UserHavingAnyRoleTwoFactorNotRequiredPolicy)
   * @request GET:/api/v1/consults/{consultId}
   * @secure
   * @response `200` `ResponseTwoFactorNotEnforcedConsultResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getClientConsult = (
    { consultId, ...query }: GetClientConsultParams,
    params: RequestParams = {},
  ) =>
    this.http.request<ResponseTwoFactorNotEnforcedConsultResponse, void>({
      path: `/api/v1/consults/${consultId}`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consults
   * @name GetClientConsults
   * @summary Get all the consults for the current user (Auth policies: ClientOrExpertPolicy, GuestOrClientOrExpertPolicy)
   * @request GET:/api/v1/consults
   * @secure
   * @response `200` `(ResponseConsultResponse)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getClientConsults = (
    query: GetClientConsultsParams,
    params: RequestParams = {},
  ) =>
    this.http.request<ResponseConsultResponse[], void>({
      path: `/api/v1/consults`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consults
   * @name GetConsultLiveStatus
   * @summary Get the consult for a given user (Auth policies: UserHavingAnyRoleTwoFactorNotRequiredPolicy)
   * @request GET:/api/v1/consults/{consultId}/live-status
   * @secure
   * @response `200` `ModelsConsultStatus` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getConsultLiveStatus = (consultId: number, params: RequestParams = {}) =>
    this.http.request<ModelsConsultStatus, void>({
      path: `/api/v1/consults/${consultId}/live-status`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
 * No description
 *
 * @tags Consults
 * @name GetSessionDetailsForAnalysis
 * @summary Get session details (transcript, notes, language) for a specific user,
filtered to sessions after the new consent date by default. (Auth policies: SupportPolicy)
 * @request GET:/api/v1/consults/session-details-for-analysis
 * @secure
 * @response `200` `(ResponseConsultsConsultSessionDetailsForAnalysisResponse)[]` OK
 * @response `401` `void` Unauthorized
 * @response `403` `void` Forbidden
 */
  getSessionDetailsForAnalysis = (params: RequestParams = {}) =>
    this.http.request<
      ResponseConsultsConsultSessionDetailsForAnalysisResponse[],
      void
    >({
      path: `/api/v1/consults/session-details-for-analysis`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consults
   * @name GetSessionNoteAttachment
   * @summary Get session note attachment file (Auth policies: GuestOrClientOrExpertPolicy)
   * @request GET:/api/v1/consults/{consultId}/attachments/{fileName}
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getSessionNoteAttachment = (
    consultId: number,
    fileName: string,
    params: RequestParams = {},
  ) =>
    this.http.request<void, void>({
      path: `/api/v1/consults/${consultId}/attachments/${fileName}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags SessionNotes
   * @name GetSessionNoteAttachment2
   * @summary  (Auth policies: ExpertPolicy)
   * @request GET:/api/v1/consults/{consultId}/session-notes/attachments/{fileName}
   * @originalName getSessionNoteAttachment
   * @duplicate
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getSessionNoteAttachment2 = (
    consultId: number,
    fileName: string,
    params: RequestParams = {},
  ) =>
    this.http.request<void, void>({
      path: `/api/v1/consults/${consultId}/session-notes/attachments/${fileName}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags SessionNotes
   * @name GetSessionNoteAttachments
   * @summary Get session note attachments (Auth policies: ExpertPolicy)
   * @request GET:/api/v1/consults/{consultId}/session-notes/attachments
   * @secure
   * @response `200` `(ResponseConsultsNoteAttachmentFile)[]` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getSessionNoteAttachments = (consultId: number, params: RequestParams = {}) =>
    this.http.request<ResponseConsultsNoteAttachmentFile[], void>({
      path: `/api/v1/consults/${consultId}/session-notes/attachments`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Transcription
   * @name GetTranscriptionSummary
   * @summary  (Auth policies: ExpertPolicy)
   * @request GET:/api/v1/consults/{consultId}/transcription/summary
   * @secure
   * @response `200` `string` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  getTranscriptionSummary = (consultId: number, params: RequestParams = {}) =>
    this.http.request<string, void>({
      path: `/api/v1/consults/${consultId}/transcription/summary`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consults
   * @name HasConsultStarted
   * @summary Checks whether a consult has started or not - to be used to determine whether cancelling/rescheduling is allowed (Auth policies: UserHavingAnyRoleTwoFactorNotRequiredPolicy)
   * @request GET:/api/v1/consults/{consultId}/started
   * @secure
   * @response `200` `boolean` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  hasConsultStarted = (consultId: number, params: RequestParams = {}) =>
    this.http.request<boolean, void>({
      path: `/api/v1/consults/${consultId}/started`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Consults
   * @name SubmitConsultReview
   * @summary Submit a review for a consult (Auth policies: GuestOrClientOrExpertPolicy)
   * @request POST:/api/v1/consults/{consultId}/review
   * @secure
   * @response `200` `void` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  submitConsultReview = (
    consultId: number,
    data: ModelsConsultReview,
    params: RequestParams = {},
  ) =>
    this.http.request<void, void>({
      path: `/api/v1/consults/${consultId}/review`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Consults
   * @name UpdateConsultStatus
   * @summary Update consult status (Auth policies: SupportOrManagingPsychologistPolicy)
   * @request PATCH:/api/v1/consults/{consultId}/status/{status}
   * @secure
   * @response `200` `ResponseConsultResponse` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  updateConsultStatus = (
    consultId: number,
    status: ModelsConsultStatus,
    params: RequestParams = {},
  ) =>
    this.http.request<ResponseConsultResponse, void>({
      path: `/api/v1/consults/${consultId}/status/${status}`,
      method: "PATCH",
      secure: true,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags SessionNotes
   * @name UploadSessionNoteAttachment
   * @summary Add session note attachment (Auth policies: ExpertPolicy)
   * @request POST:/api/v1/consults/{consultId}/session-notes/attachments
   * @secure
   * @response `200` `ResponseConsultsNoteAttachmentFile` OK
   * @response `401` `void` Unauthorized
   * @response `403` `void` Forbidden
   */
  uploadSessionNoteAttachment = (
    consultId: number,
    data: UploadSessionNoteAttachmentPayload,
    params: RequestParams = {},
  ) =>
    this.http.request<ResponseConsultsNoteAttachmentFile, void>({
      path: `/api/v1/consults/${consultId}/session-notes/attachments`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });
}
